var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBalanceConvert = function SvgBalanceConvert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BalanceConvert_svg__Swap"
  }, /*#__PURE__*/React.createElement("path", {
    id: "BalanceConvert_svg__Vector",
    d: "M10.0001 5.83442L6.66673 2.50109L3.3334 5.83442",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BalanceConvert_svg__Vector_2",
    d: "M6.66673 2.50109V11.6678",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BalanceConvert_svg__Vector_3",
    d: "M10 14.1663L13.3333 17.4996L16.6667 14.1663",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BalanceConvert_svg__Vector_4",
    d: "M13.3334 17.5004V8.33374",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentColor"
  }))));
};
export default SvgBalanceConvert;